import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Survey from './components/Survey/Survey';
import SurveyForm from './components/Survey/SurveyForm';
import SurveyError from './components/SurveyError/SurveyError';
import Unsubscribe from './components/Unsubscribe/Unsubscribe';
import NotFound from './components/NotFound/NotFound'; 
import ErrorReportForm from './components/ErrorReportForm/ErrorReportForm';
import ReviewCompleted from './components/Completed/ReviewCompleted';
import './App.scss'
import SurveyCompletedNew from './components/SurveyCompleted/SurveyCompletedNew';

const App = () => {
    return (
        <Router>
            <Routes>
                {/* <Route path="/" element={<Survey />} /> */}
                <Route path="/reviews/pcv2/response/:responseId" element={<SurveyForm />} />
                <Route path="/completed" element={<SurveyCompletedNew />} />
                <Route path="/review-completed" element={<ReviewCompleted />} />
                <Route path="/error" element={<SurveyError />} />
                <Route path="/unsubscribe" element={<Unsubscribe />} />
                <Route path="/reviews/pcv2/correction/:reviewEmailId" element={<ErrorReportForm />} />
                <Route path="*" element={<NotFound />} /> 
            </Routes>
        </Router>
    );
};

export default App;
